import { useEffect, useState } from 'react'
import { Organization } from 'lib/types'
import { POIMatch, matchPOIsToBeaconsFromMaps } from 'lib/utils/mappedin'
import { useMappedInPOIs } from 'hooks/usePOIs'
import { useMappedInSpaces, useReactMobileRooms } from 'hooks/useSpaces'
import { space } from 'styled-system'
import { getAppColors } from 'lib/constants'

type Props = {
  onNext: (data: { matchedPOIs: Record<string, POIMatch>; spaceMap: any }) => void
  goBack: () => void
  data: {
    org: Organization | null
    matchedFloors: { mi: { id: string; name: string }; rm: string }[]
    matchedSpaces: Record<string, Record<string, string>>
  }
}

export default function Step4MatchPOIs({ onNext, goBack, data }: Props) {
  console.log('~~step4-data:', data)
  const [matches, setMatches] = useState<Record<string, POIMatch>>({})

  const mappedinPOIs = useMappedInPOIs(data.org?.mappedin)
  const spaceMap = useMappedInSpaces(data.org?.mappedin)
  const roomMap = useReactMobileRooms(data.org?.id || '')
  console.log('~~step4-spaceMap:', spaceMap)
  console.log('~~step4-roomMap:', roomMap)

  useEffect(() => {
    if (!mappedinPOIs.length || !Object.keys(spaceMap).length || !Object.keys(roomMap).length) {
      console.warn('~~step4: waiting for data to load...')
      return
    }

    const floorMap: Record<string, string> = {}
    data.matchedFloors.forEach(f => {
      floorMap[f.mi.id] = f.rm
    })

    console.log('~~step4: 🧠 Starting POI-to-beacon match...')
    const result = matchPOIsToBeaconsFromMaps(mappedinPOIs, floorMap, data.matchedSpaces, spaceMap, roomMap)

    console.log('~~step4: ✅ Finished matching POIs', result)
    setMatches(result)
  }, [mappedinPOIs, spaceMap, roomMap, data.matchedFloors, data.matchedSpaces])

  const handleSubmit = () => {
    console.log('~~submit spaceMap', spaceMap)
    onNext({ matchedPOIs: matches, spaceMap: spaceMap })
  }

  const floorIdToName: Record<string, string> = {}
  data.matchedFloors.forEach(f => {
    floorIdToName[f.mi.id] = f.rm
  })

  const groupedByFloor: Record<string, POIMatch[]> = {}
  Object.values(matches).forEach(match => {
    const floorKey = floorIdToName[match.coordinates.floorId] || match.coordinates.floorId || 'Unknown'
    if (!groupedByFloor[floorKey]) groupedByFloor[floorKey] = []
    groupedByFloor[floorKey].push(match)
  })

  return (
    <div>
      <h2>Step 4: Match POIs to Beacons</h2>
      <p style={{ marginBottom: '1rem' }}>
        The following POIs have been matched to beacons using floor, space, and name logic.
      </p>

      {Object.entries(groupedByFloor)
        .sort(([a], [b]) => a.localeCompare(b)) // Sort floor sections alphabetically
        .map(([floor, group]) => {
          const sortedGroup = [...group].sort((a, b) => a.poiName.localeCompare(b.poiName))

          return (
            <div key={floor} style={{ marginBottom: '2rem' }}>
              <h3>{floor}</h3>
              <ul style={{ paddingLeft: '1rem' }}>
                {sortedGroup.map(match => (
                  <li key={match.poiId} style={{ marginBottom: '0.5rem', color: 'green' }}>
                    ✅ <strong>{match.poiName}</strong> → Room: <em>{match.roomName}</em> → Beacon ID:{' '}
                    <code>{match.beaconId}</code>
                  </li>
                ))}
              </ul>
            </div>
          )
        })}

      <button
        onClick={goBack}
        style={{
          marginTop: '1rem',
          padding: '0.5rem 1.25rem',
          marginRight: '1rem',
          backgroundColor: getAppColors('--color-border'),
          border: 'none',
          borderRadius: '4px',
          cursor: 'pointer',
        }}
      >
        ← Back
      </button>

      <button
        onClick={handleSubmit}
        style={{
          marginTop: '2rem',
          padding: '0.75rem 1.5rem',
          backgroundColor: '#29a096',
          color: 'white',
          fontWeight: 'bold',
          border: 'none',
          borderRadius: '4px',
          cursor: 'pointer',
        }}
      >
        Continue
      </button>
    </div>
  )
}
